<template>
  <strategy-dashboard-modal :strategy="strategy" />

  <a-button
    block
    type="text"
    class="strategy__action-download table-cell__actions-btn"
    :disabled="isGlobalDownloading"
    @click="handleDownloadStrategy"
  >
    <!-- <a-tooltip :overlayStyle="{ width: loading && '175px' }">
      <template #title>
        <span v-if="isGlobalDownloading">Tiene una descarga pendiente</span>
        <span v-else>
          {{ loading ? "Su descarga estará lista en unos instantes" : "Descargar" }}
        </span>
      </template>
    </a-tooltip> -->
    <template #icon>
      <LoadingOutlined v-if="loading" />
      <VerticalAlignBottomOutlined
        v-else
        :style="{
          fontSize: '16px',
        }"
      />
    </template>
    <p>Descargar reporte</p>
  </a-button>
</template>

<script>
import { ref, provide, computed, watch } from "vue";
import { useStore } from "vuex";
import { VerticalAlignBottomOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { Modal, message } from "ant-design-vue";

import { downloadFile } from "@/app/shared/utils/file";

import StrategyDashboardModal from "@/app/strategies/components/modals/StrategyDashboardModal.vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";

export default {
  components: {
    VerticalAlignBottomOutlined,
    LoadingOutlined,
    StrategyDashboardModal,
  },
  props: {
    strategy: {
      required: true,
      type: Object,
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const clientLoading = ref(false);
    const { isGlobalDownloading } = useGlobalDownloadState();

    const serverLoading = computed(() => props.strategy.in_download);
    const loading = computed(() => clientLoading.value || serverLoading.value);

    provide("clientLoading", clientLoading);
    provide("serverLoading", serverLoading);

    const handleDownloadStrategy = async () => {
      await new Promise((res) => {
        Modal.confirm({
          centered: true,
          title: `¿Estás seguro de descargar ${props.strategy.total_phones} registros de la estrategia ${props.strategy.name}?`,
          okText: "Descargar",
          onOk: () => res(),
        });
      });

      try {
        clientLoading.value = true;

        const response = await store.dispatch("downloadStrategy", props.strategy.id);

        downloadFile(response, `${props.strategy.name}.xlsx`, { useResponseFileName: true });
      } catch (error) {
        const errorMessage = error?.getErrorMessage() || "Ha ocurrido un error";
        message.error(errorMessage);
      } finally {
        clientLoading.value = false;
      }
    };

    watch(
      () => clientLoading.value,
      (newValue) => {
        emit("isLoading", newValue);
      }
    );

    return {
      loading,
      isGlobalDownloading,
      handleDownloadStrategy,
    };
  },
};
</script>
<!-- 
<style lang="sass">
@import '@/app/shared/assets/table-cell-actions.sass'


// .strategy__action-download.ant-btn-loading
//   pointer-events: auto !important
//   cursor: default
</style> -->
